import { render, staticRenderFns } from "./BaseMultiSelectComboBox.vue?vue&type=template&id=545afaca"
import script from "./BaseMultiSelectComboBox.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelectComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports